import SiteLogoPresentation from 'components/SiteLogo/SiteLogoPresentation'

export default {
  Presentation: SiteLogoPresentation,
}
